import request from '@/utils/request'


// 查询医师认证信息列表
export function listAuth(query) {
  return request({
    url: '/doctor/auth/list',
    method: 'get',
    params: query
  })
}

// 查询医师认证信息分页
export function pageAuth(query) {
  return request({
    url: '/doctor/auth/page',
    method: 'get',
    params: query
  })
}

// 查询医师认证信息详细
export function getAuth(data) {
  return request({
    url: '/doctor/auth/detail',
    method: 'get',
    params: data
  })
}

// 新增医师认证信息
export function addAuth(data) {
  return request({
    url: '/doctor/auth/add',
    method: 'post',
    data: data
  })
}

// 修改医师认证信息
export function updateAuth(data) {
  return request({
    url: '/doctor/auth/edit',
    method: 'post',
    data: data
  })
}

export function checkDoctor(data) {
  return request({
    url: '/doctor/auth/check',
    method: 'post',
    data: data
  })
}

// 删除医师认证信息
export function delAuth(data) {
  return request({
    url: '/doctor/auth/delete',
    method: 'post',
    data: data
  })
}
